import Vue from 'vue'

//執行環境
let subDomain = window.location.host.substring(0, window.location.host.indexOf('.'));
let env;
if (subDomain.indexOf('mycrm') >= 0) {
  if (subDomain === 'tmycrm') {
    env = 'test';
  } else if (subDomain === 'smycrm') {
    env = 'stage';
  } else {
    env = 'production';
  }
} else {
  env = 'localhost';
}

window.env = env;

//難字宣告 window 全域
if (env === 'production') {
  window.imeServer = "https://mi.cathaylife.com.tw/wf/";
} else if (env === 'stage') {
  window.imeServer = "https://smi.cathaylife.com.tw/wf/";
} else {
  window.imeServer = "https://tmi.cathaylife.com.tw/wf/";
}
window.WebRootPath = `/crm/js/`;

// 全域宣告 mixin
Vue.mixin({
  data() {
    return {
      env: 'localhost'
    }
  },
  methods: {
    setToastMsg(msg) {
      this.$toast.removeAll() // 清除前面顯示的提醒框
      this.$toast.info({
        title: msg
      })
    },
    registerHanlink() { // 難字過濾
      
      // // Kerry 前端開發環境測試用
      // setTimeout(()=>{
      //   let jscript = document.createElement("script");
      //   jscript.setAttribute("lang", "text/javascript");
      //   jscript.setAttribute("src","/crm/js/hanlinks/wf_links.min.js");
      //   document
      //     .getElementsByTagName("head")
      //     .item(0)
      //     .appendChild(jscript);
      // },200)

      // 宗翰調整正式版本
      if (!window.AJADev) { //  離線模式不啟用
        if ("function" === typeof (parseEUDC)) {
          this.bindTextEUDC();
          setTimeout(function () {
            window.parseEUDC("ap")
          }, 100)
        } else {
          // 移除輸入法DIV
          var el = document.getElementsByClassName("ime-window");
          if (el.length > 0) {
            for (let i = 0; i < el.length; i++) {
              el[i].parentNode.removeChild(el[i]);
            }
          }

          // 移除 hanklink
          var oHanklink = document.getElementsByTagName("hanklink");
          if (oHanklink.length > 0) {
            for (let i = 0; i < oHanklink.length; i++) {
              oHanklink[i].parentNode.removeChild(oHanklink[i]);
            }
          }

          let hanklink = document.createElement("hanklink");
          let jscript = document.createElement("script")
          let cVue = this;
          jscript.onload = function () {
            cVue.bindTextEUDC();
            cVue.parseEUDC();
          };
          

          jscript.setAttribute("lang", "text/javascript")
          jscript.setAttribute('src', `${process.env.BASE_URL}js/hanlinks/wf_links.js`)
          
          setTimeout(() => {
            document.getElementsByTagName("head").item(0).appendChild(hanklink);
            hanklink.appendChild(jscript);
          }, 200);

        }
      }
    },
    bindTextEUDC() {
      let nodeList = document.querySelectorAll([`input[alt="ch"]`]);
      for (var item of nodeList) {
        this.bindInputEvent(item);
      }
    },
    bindInputEvent(element) {
      element.addEventListener("focusout", function () {
        if (typeof Event === "function") {
          element.dispatchEvent(new Event("input"));
        } else {
          // for IE
          var event = document.createEvent("Event");
          event.initEvent("input", true, true);
          element.dispatchEvent(event);
        }
      });
    },
    parseEUDC() {
      if ("function" === typeof window.parseEUDC) {
        window.parseEUDC("ap");
      }
    }
  },
  computed: {
    throttleRegisterHanlink() {
      return this.golbalThrottle(this.registerHanlink, 100)
    }
  }
})
